import { Link, NavLink, Outlet } from 'react-router-dom';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { translate } from '../i18n';

const isProd = (import.meta.env.VITE_PAYLOAD_API_URL ?? '').includes('hscxv6shsf');

const getBrandName = (locale: 'en' | 'zh'): string => {
  if (isProd) {
    return translate(locale, 'siteTitle');
  }
  return locale === 'zh' ? '淞圣.DEV' : 'SONSEN.DEV';
};

const Layout = () => {
  const { locale } = useLanguage();
  const { resolved } = useTheme();

  const logoSrc = resolved === 'dark' ? '/logo-dark.svg' : '/logo-light.svg';
  const brandName = getBrandName(locale);

  return (
    <div className="app-shell">
      <header className="top-nav">
        <div className="brand">
          <Link to="/">
            <img
              className="brand__logo"
              src={logoSrc}
              alt={brandName}
            />
            <span className="brand__name">{brandName}</span>
          </Link>
        </div>
        <nav className="primary-nav" aria-label="Primary">
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)}>
            {translate(locale, 'collection')}
          </NavLink>
          <NavLink to="/stories" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            {translate(locale, 'stories')}
          </NavLink>
          <NavLink to="/authors" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            {translate(locale, 'authors')}
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            {translate(locale, 'about')}
          </NavLink>
        </nav>
        <div className="nav-controls">
          <ThemeSwitcher />
          <LanguageSwitcher />
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
